import { cn } from '@/lib/cn';

interface ProgressBarProps {
  value: number;
  max: number;
  className?: string;
  /** CSS rang — indikatorni difficulty rangiga bo'yash uchun. */
  color?: string;
}

export function ProgressBar({ value, max, className, color }: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div className={cn('progress-bar', className)}>
      <div
        className="progress-fill"
        style={{ width: `${pct}%`, ...(color ? { background: color } : {}) }}
      />
    </div>
  );
}
